var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"hover-intent",rawName:"v-hover-intent",value:({
    onEnter: () => _vm.$emit('preview', _vm.option),
    onExit: () => _vm.$emit('preview', null)
  }),expression:"{\n    onEnter: () => $emit('preview', option),\n    onExit: () => $emit('preview', null)\n  }"}],staticClass:"option-card",class:[
    _vm.layout === 'horizontal' ? 'flex-row' : 'flex-col',
    {
      loading: _vm.loading,
      disabled: _vm.disabled
    },
  ],on:{"click":_vm.handleClick}},[(!_vm.$slots.default)?[_c('aha-spinner',{staticClass:"option-card-loader",class:{
        'visible': _vm.loading,
      },attrs:{"variant":'dark',"size":"sm"}}),_c('div',{staticClass:"option-card-img"},[_c('aha-icon',{attrs:{"name":_vm.option.icon,"maintainColor":""}})],1),_c('div',{staticClass:"option-card-title font-bold text-base"},[_vm._v("\n      "+_vm._s(_vm.option.name)+"\n    ")])]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }